import { TechDocPage } from '../containers/pages';
import { ALLETRA9k_VIDEO_URL } from '../constants';
const configPath = '/software-config/';
export const softwareConfig = [
  {
    path: configPath,
    menuText: 'softwareConfig',
    exact: true,
    redirectTo: `${configPath}/arrayDiscovery`,
    submenuItems: [
      {
        path: `${configPath}/arrayDiscovery`,
        menuText: 'arrayDiscovery',
        exact: true,
        component: TechDocPage,
        pageProps: {},
      },
      {
        path: `${configPath}/connectArray`,
        menuText: 'connectArray',
        exact: true,
        component: TechDocPage,
        pageProps: {
          videoUrl: ALLETRA9k_VIDEO_URL.CONNECTARRAY,
        },
      },
      {
        path: `${configPath}/arraySetup`,
        menuText: 'arraySetup',
        exact: true,
        component: TechDocPage,
        pageProps: {
          videoUrl: ALLETRA9k_VIDEO_URL.SETUPARRAY,
        },
      },
      {
        path: '/powerup-init/completeSetup',
        menuText: 'setupComplete',
        exact: true,
        component: TechDocPage,
        pageProps: {},
      },
    ],
  },
];
